import React, {useEffect, useState} from 'react';
import {Menu} from 'antd';
import {useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import SidebarJson from "./SidebarJson";
import {handleSidebarStatus} from "../store/SettingRedux/SettingRedux";


const Sidebar = () => {
    const location = useLocation();
    const sidebarStatus = useSelector((state) => state.SettingRedux.sidebarStatus);
    const [current, setCurrent] = useState(location?.pathname);
    const [items] = SidebarJson();
    const dispatch = useDispatch();
    const [screenWidth, setScreenWidth] = useState();


    useEffect(() => {
        const setScreenSize = () => {
            const width = window.innerWidth
            setScreenWidth(window.innerWidth)
            if (width < 1024) {
                dispatch(handleSidebarStatus(3))
            } else {
                dispatch(handleSidebarStatus(1))
            }
        }
        setScreenSize()
        window.addEventListener('resize', setScreenSize);


        return (() => {
            window.removeEventListener('resize', setScreenSize);
        })
    }, [dispatch])


    useEffect(() => {
        setCurrent(location?.pathname)
    }, [location?.pathname])

    useEffect(() => {
        if (screenWidth < 1024) {
            dispatch(handleSidebarStatus(3))
        }

    }, [dispatch,screenWidth,location?.pathname])
    const onClick = (e) => {
        setCurrent(e.key);
    };


    return (<div> <span className={`layer lg:hidden ${sidebarStatus === 3 && 'hidden'}`} onClick={() => {
        dispatch(handleSidebarStatus(3))
    }}> </span>
             <div
                className={`sideBarMenu sideBarTransition z-10  ${sidebarStatus === 1 ? 'fullSidebar' : sidebarStatus === 2 ? 'miniSidebar' : 'hiddenSidebar'}`}


            >

                <Menu
                    onClick={onClick}

                    defaultOpenKeys={['1', '2', '3', '4', '5', '6']}
                    selectedKeys={[current]}
                    mode="inline" className='h-full'
                    items={items}
                    inlineCollapsed={sidebarStatus === 2}
                />

         </div>

    </div>);
};
export default Sidebar;